/* eslint-disable prettier/prettier */

// Store Code → Store Number mapping
export const HT_ID_MAP = {
  'jq3': '08105', 'kev': '08501', 'kew': '08502', 'kex': '08503', 'key': '08504',
  'kf0': '08505', 'kfl': '08506', 'kf2': '08507', 'kf3': '08508', 'kf4': '08509',
  'kf5': '08510', 'kf6': '08511', 'kf7': '08512', 'kf8': '08513', 'kf9': '08514',
  'kfa': '08515', 'kfc': '08517', 'kfd': '08518', 'kff': '08520', 'kfg': '08521',
  'kfh': '08522', 'kfj': '08523', 'kfk': '08524', 'kfm': '08525', 'kfn': '08526',
  'kfp': '08527', 'kfq': '08528', 'kfr': '08529', 'kft': '08530', 'kfu': '08531',
  'kfv': '08532', 'kfw': '08533', 'kfx': '08534', 'kfy': '08535', 'kg0': '08536',
  'kg1': '08537', 'kg2': '08538', 'kg4': '08540', 'kg5': '08541', 'kg6': '08542',
  'kg7': '08543', 'kg8': '08544', 'kg9': '08545', 'kga': '08546', 'kgb': '08547',
  'kgc': '08548', 'kgd': '08549', 'kge': '08550', 'kgg': '08552', 'kgh': '08553',
  'kgj': '08554', 'kgk': '08555', 'kgm': '08556', 'kgq': '08559', 'kgr': '08560',
  'kgt': '08561', 'kgu': '08562', 'kgv': '08563', 'kgw': '08564', 'kgx': '08565',
  'kgy': '08566', 'kh0': '08567', 'kh1': '08568', 'kh2': '08569', 'kh3': '08570',
  'kh4': '08571', 'kh5': '08572', 'kh6': '08573', 'kh7': '08574', 'kh8': '08575',
  'kh9': '08576', 'kha': '08577', 'khb': '08578', 'khd': '08580', 'khe': '08581',
  'khg': '08583', 'khh': '08584', 'khk': '08586', 'khm': '08587', 'khn': '08588',
  'khp': '08589', 'khq': '08590', 'khr': '08591', 'kht': '08592', 'khu': '08593',
  'khv': '08594', 'khw': '08595', 'khx': '08596', 'khy': '08597', 'kj2': '08600',
  'kj3': '08601', 'kj5': '08603', 'kj6': '08604', 'kj8': '08606', 'kj9': '08607',
  'kja': '08608', 'kjb': '08609', 'kjc': '08610', 'kje': '08612', 'kjf': '08613',
  'kjg': '08614', 'kjh': '08615', 'kjj': '08616', 'kjk': '08617', 'kjm': '08618',
  'kjp': '08620', 'kjq': '08621', 'kjr': '08622', 'kjt': '08623', 'kjv': '08625',
  'kjw': '08626', 'kjx': '08627', 'kjy': '08628', 'kk0': '08629', 'kk1': '08630',
  'kk2': '08631', 'kk3': '08632', 'kk4': '08633', 'kk5': '08634', 'kk6': '08635',
  'kk7': '08636', 'kk8': '08637', 'kk9': '08638', 'kka': '08639', 'kkb': '08640',
  'kkd': '08642', 'kke': '08643', 'kkh': '08646', 'kkj': '08647', 'kkk': '08648',
  'kkm': '08649', 'kkn': '08650', 'kkp': '08651', 'kkq': '08652', 'kkr': '08653',
  'kkt': '08654', 'kku': '08655', 'kkv': '08656', 'kkw': '08657', 'kkx': '08658',
  'kky': '08659', 'km0': '08660', 'km1': '08661', 'km3': '08663', 'km4': '08664',
  'km5': '08665', 'km7': '08667', 'km8': '08668', 'km9': '08669', 'kma': '08670',
  'kmc': '08672', 'kmd': '08673', 'kme': '08674', 'kmf': '08675', 'kmg': '08676',
  'kmh': '08677', 'kmj': '08678', 'kmk': '08679', 'kmm': '08680', 'kmn': '08681',
  'kmp': '08682', 'kmq': '08683', 'kmr': '08684', 'kmv': '08687', 'kmw': '08688',
  'kmx': '08689', 'kmy': '08690', 'kn1': '08692', 'kn2': '08693', 'kn3': '08694',
  'kn4': '08695', 'kn5': '08696', 'kn6': '08697', 'kn7': '08698', 'knb': '08702',
  'knd': '08704', 'knf': '08706', 'kng': '08707', 'knh': '08708', 'knj': '08709',
  'knm': '08711', 'knn': '08712', 'knp': '08713', 'knq': '08714', 'knr': '08715',
  'knt': '08716', 'knu': '08717', 'knv': '08718', 'knw': '08719', 'knx': '08720',
  'kny': '08721', 'kp0': '08722', 'kp1': '08723', 'kp2': '08724', 'kp3': '08725',
  'kp4': '08726', 'kp5': '08727', 'kp6': '08728', 'kp7': '08729', 'kp8': '08730',
  'kp9': '08731', 'kpa': '08732', 'kpb': '08733', 'kpc': '08734', 'krg': '08800',
  'krh': '08801', 'krj': '08802', 'krk': '08803', 'krm': '08804', 'krn': '08805',
  'krp': '08806', 'krq': '08807', 'krr': '08808', 'krt': '08809', 'kru': '08810',
  'krv': '08811', 'krw': '08812', 'krx': '08813', 'kry': '08814', 'kt0': '08815',
  'kt1': '08816', 'kt2': '08817', 'kt3': '08818', 'kt4': '08819', 'kt5': '08820',
  'kt6': '08821', 'kt7': '08822', 'kt8': '08823', 'kt9': '08824', 'kta': '08825',
  'ktb': '08826', 'ktc': '08827', 'ktd': '08828', 'kte': '08829', 'ktf': '08830',
  'ktg': '08831', 'kth': '08832', 'ktj': '08833', 'ktk': '08834', 'ktm': '08835',
  'ktn': '08836', 'ktp': '08837', 'ktq': '08838', 'ktr': '08839', 'ktt': '08840',
  'ktu': '08841', 'ktv': '08842', 'ktx': '08844', 'kty': '08845', 'ku0': '08846',
  'ku1': '08847', 'ku2': '08848'
};
